import styled from 'styled-components';
import * as ds from '@bob/design-system';
export var Main = styled.div.withConfig({
  displayName: "DetailLayout__Main",
  componentId: "sc-813an2-0"
})(["@media screen and (", "){padding-left:40px;}@media screen and (", "){padding-left:90px;}@media screen and (", "){padding-left:140px;}"], ds.breakpoint.TABLET, ds.breakpoint.LAPTOP, ds.breakpoint.LAPTOP_L);
export var GalleryColumn = styled.div.withConfig({
  displayName: "DetailLayout__GalleryColumn",
  componentId: "sc-813an2-1"
})(["margin-top:-10px;@media screen and (", "){margin-top:-20px;}", ",", "{position:sticky;top:90px;}position:relative;"], ds.breakpoint.TABLET, ds.Gallery, ds.GallerySkeleton);
export var Container = styled(ds.Container).withConfig({
  displayName: "DetailLayout__Container",
  componentId: "sc-813an2-2"
})(["@media screen and (", "){display:flex;flex-direction:row;flex-wrap:wrap;}", ",", "{flex:0 0 100%;margin-bottom:15px;@media screen and (", "){margin-bottom:32px;}}", "{flex:1 1 25%;}", "{flex:2;}"], ds.breakpoint.TABLET, ds.BreadCrumbs, ds.BreadCrumbsSkeleton, ds.breakpoint.TABLET, GalleryColumn, Main);